<div class="title">
  <mat-icon>corporate_fare</mat-icon>
  TextSet Definitions
</div>
<div class="description">SELECT THE TEXTSET TO FILTER BY</div>

@if (textSetDefinitions$ | async; as textSetDefinitions) {
  <div class="options">
    @for (textSetDefinition of textSetDefinitions; track textSetDefinition) {
      <elements-filter-chip
        icon="sell"
        [caption]="textSetDefinition.name"
        [selected]="isSelected(textSetDefinition)"
        (click)="isSelected(textSetDefinition) ? remove(textSetDefinition) : add(textSetDefinition)"
        >
      </elements-filter-chip>
    }
  </div>
} @else {
  <elements-loading-spinner></elements-loading-spinner>
}

<div class="actions">
  <button styles-button (click)="close.emit()">Filter</button>
  <button styles-low-button (click)="clear()">Clear</button>
</div>

